import { render, staticRenderFns } from "./view-focus-topics.vue?vue&type=template&id=128c8926"
import script from "./view-focus-topics.ts?vue&type=script&lang=ts&external"
export * from "./view-focus-topics.ts?vue&type=script&lang=ts&external"
import style0 from "./view-focus-topics.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128c8926')) {
      api.createRecord('128c8926', component.options)
    } else {
      api.reload('128c8926', component.options)
    }
    module.hot.accept("./view-focus-topics.vue?vue&type=template&id=128c8926", function () {
      api.rerender('128c8926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/focus-topics/view-focus-topics/view-focus-topics.vue"
export default component.exports